import { render, staticRenderFns } from "./dialogueM3.vue?vue&type=template&id=b85731d0&"
import script from "./dialogueM3.vue?vue&type=script&lang=js&"
export * from "./dialogueM3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports